import React, { useRef, useEffect, useState } from "react";
import { ContainerMetrics, RowContainer, Button, ButtonContainer, ContainerChart } from "./styles";
import { ColumnChart, DonutChart, ColumnChartSmall, ColumnColumnClients } from "./Charts";
import { convertDataToExcel } from "../../../../utils/functions";
import { data } from "./data_excel";
import Pdf from "react-to-pdf";

export const Metrics = () => {
  const containerRef = useRef();
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (containerRef.current) {
      setContainerSize({
        width: containerRef.current.offsetWidth,
        height: containerRef.current.scrollHeight,
      });
    }
  }, []);

  const options = {
    orientation: "portrait",
    unit: "pt",
    format: [containerSize.width, containerSize.height],
    putOnlyUsedFonts: true,
    precision: 100000000,
    floatPrecision: "smart",
  };

  const handleExcelPress = () => {
    convertDataToExcel(data);
  };

  return (
    <ContainerMetrics>
      <ContainerChart ref={containerRef} style={{ minHeight: containerSize.height }}>
        <ColumnColumnClients />
        <ColumnChart />
        <RowContainer>
          <DonutChart />
          <ColumnChartSmall />
        </RowContainer>
      </ContainerChart>

      <ButtonContainer>
        <Pdf targetRef={containerRef} options={options} filename="dashboard.pdf">
          {({ toPdf }) => <Button onClick={toPdf}>PDF</Button>}
        </Pdf>
        <Button onClick={handleExcelPress}>Excel</Button>
      </ButtonContainer>
    </ContainerMetrics>
  );
};
